import { render, staticRenderFns } from "./Users.html?vue&type=template&id=48e6c1d2&scoped=true&"
import script from "./Users.js?vue&type=script&lang=js&"
export * from "./Users.js?vue&type=script&lang=js&"
import style0 from "./Users.scss?vue&type=style&index=0&id=48e6c1d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e6c1d2",
  null
  
)

export default component.exports